(function () {
  "use strict";

  // planaplana – Ausverkaufte Buchhüllenfarben im Konfigurator sichtbar machen +
  // Schleifen-Haken an den Lagertopf koppeln + aktive Farbe deutlicher hervorheben +
  // fixierte Vorschau-Hülle beim Scrollen komplett sichtbar halten (unter dem Header).
  // Gilt einheitlich für alle Buchhüllen-Konfiguratoren; alles automatisch aus dem
  // echten Shopify-Bestand.

  var dataEl = document.getElementById('pl-bhk-product-data');
  var swatchesEl = document.getElementById('swatches');
  if (!dataEl || !swatchesEl) return;

  var product;
  try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!product || !Array.isArray(product.variants)) return;

  // Verfügbarkeit je Farbe (option1) ableiten, zusätzlich getrennt nach
  // mit/ohne Schleife (option3 enthält "Schleife" = mit-Schleife-Topf).
  var hasVariant = {}, available = {};
  var mitHas = {}, mitAvail = {}, ohneHas = {}, ohneAvail = {};
  product.variants.forEach(function (v) {
    var c = v.option1;
    if (c == null) return;
    var avail = v.available !== false;
    hasVariant[c] = true;
    if (avail) available[c] = true;
    var isMit = typeof v.option3 === 'string' && v.option3.indexOf('Schleife') > -1;
    if (isMit) { mitHas[c] = true; if (avail) mitAvail[c] = true; }
    else { ohneHas[c] = true; if (avail) ohneAvail[c] = true; }
  });
  function isSoldOut(name) { return !!hasVariant[name] && !available[name]; }

  // Styles einmalig injizieren (self-contained, kein CSS-Datei-Edit nötig).
  // Nur der Farbkreis wird durchgestrichen – Farbe und Label bleiben unverändert.
  if (!document.getElementById('pl-bhk-soldout-style')) {
    var st = document.createElement('style');
    st.id = 'pl-bhk-soldout-style';
    st.textContent = [
      '.pl-bhk .swatch-wrap.sold-out{cursor:not-allowed;pointer-events:none;}',
      '.pl-bhk .swatch-wrap.sold-out .swatch::after{content:"";position:absolute;inset:-3px;background:linear-gradient(to top left,transparent calc(50% - 1.2px),#8a8a8a calc(50% - 1.2px),#8a8a8a calc(50% + 1.2px),transparent calc(50% + 1.2px));}',
      '.pl-bhk .sold-note{font-size:10px;font-weight:600;letter-spacing:.03em;text-transform:uppercase;color:#b06a6a;margin-top:-1px;line-height:1.1;}',
      '.pl-bhk .schleife-toggle.pl-schleife-locked{opacity:.5;pointer-events:none;}',
      '.pl-bhk .pl-schleife-note{font-size:11px;color:#b06a6a;margin-top:6px;line-height:1.35;}',
      // Aktive Farbe deutlicher: grünen Foto-Ring bei NICHT gewählten Farben entfernen,
      // bei der aktiven Farbe den dünnen grünen Ring als Markierung stehen lassen
      // (überlappt das Label nicht). Gilt für alle Konfiguratoren (Klasse .pl-active-clear).
      '.pl-bhk.pl-active-clear .swatch.has-photo::before{display:none;}',
      '.pl-bhk.pl-active-clear .swatch-wrap.active .swatch.has-photo::before{display:block;}',
      // Fixierte Vorschau-Hülle: Abstand unter den 64px hohen, sticky Header legen
      // (top:80) und die Höhe auf kleineren Fenstern begrenzen, damit die Hülle beim
      // Scrollen komplett (auch die Oberkante) sichtbar bleibt und erst beim Erscheinen
      // des Add-to-Cart mitscrollt. Auf großen Monitoren ohne spürbare Wirkung.
      '@container plbhk (min-width: 640px){.pl-bhk .preview-column{top:80px !important;}.pl-bhk .cover{max-height:calc(100vh - 150px) !important;}}'
    ].join('');
    document.head.appendChild(st);
  }

  // Aktiv-Hervorhebung für ALLE Konfiguratoren aktivieren.
  var plContainer = swatchesEl.closest('.pl-bhk');
  if (plContainer) plContainer.classList.add('pl-active-clear');

  function markSwatches() {
    var wraps = swatchesEl.querySelectorAll('.swatch-wrap');
    if (!wraps.length) return false;
    var firstAvailableWrap = null;
    var activeIsSoldOut = false;
    wraps.forEach(function (wrap) {
      var labelEl = wrap.querySelector('.swatch-label');
      if (!labelEl) return;
      var name = labelEl.textContent.trim();
      if (isSoldOut(name)) {
        if (!wrap.classList.contains('sold-out')) {
          wrap.classList.add('sold-out');
          wrap.setAttribute('aria-disabled', 'true');
          wrap.title = name + ' ist aktuell ausverkauft';
          if (!wrap.querySelector('.sold-note')) {
            var note = document.createElement('div');
            note.className = 'sold-note';
            note.textContent = 'Ausverkauft';
            wrap.appendChild(note);
          }
        }
        if (wrap.classList.contains('active')) activeIsSoldOut = true;
      } else if (!firstAvailableWrap) {
        firstAvailableWrap = wrap;
      }
    });
    // Falls die Standard-Farbe ausverkauft ist, automatisch die erste lieferbare wählen.
    if (activeIsSoldOut && firstAvailableWrap) {
      firstAvailableWrap.click();
    }
    return true;
  }

  // ===== Schleifen-Haken an den Lagertopf koppeln (nur Leo/Wildleder) =====
  function activeColorName() {
    var a = swatchesEl.querySelector('.swatch-wrap.active .swatch-label');
    return a ? a.textContent.trim() : null;
  }

  function ensureSchleifeNote(toggle) {
    var grp = toggle.closest('.control-group') || toggle.parentNode;
    var note = grp.querySelector('.pl-schleife-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'pl-schleife-note';
      note.style.display = 'none';
      grp.appendChild(note);
    }
    return note;
  }

  function evaluateSchleife() {
    var toggle = document.getElementById('schleifeToggle');
    if (!toggle) return; // Kieselleder o.ä. ohne Schleifen-Option
    var name = activeColorName();
    if (!name) return;
    var pressed = toggle.getAttribute('aria-pressed') === 'true';
    var note = ensureSchleifeNote(toggle);

    if (mitHas[name] && !mitAvail[name] && ohneAvail[name]) {
      // "mit Schleife"-Topf leer → Haken sperren (aus)
      if (pressed) toggle.click();
      toggle.classList.add('pl-schleife-locked');
      toggle.setAttribute('aria-disabled', 'true');
      note.textContent = 'Die Variante mit Verschluss-Schleife ist bei dieser Farbe aktuell ausverkauft.';
      note.style.display = '';
    } else if (ohneHas[name] && !ohneAvail[name] && mitAvail[name]) {
      // "ohne Schleife"-Topf leer → nur mit Schleife möglich → Haken an + sperren
      if (!pressed) toggle.click();
      toggle.classList.add('pl-schleife-locked');
      toggle.setAttribute('aria-disabled', 'true');
      note.textContent = 'Diese Farbe ist aktuell nur mit Verschluss-Schleife verfügbar.';
      note.style.display = '';
    } else {
      // beide Töpfe verfügbar (oder Farbe ganz ausverkauft → eigene Sperre) → frei
      toggle.classList.remove('pl-schleife-locked');
      toggle.removeAttribute('aria-disabled');
      note.style.display = 'none';
    }
  }

  function run() {
    // Bei jedem Farbwechsel den Schleifen-Haken neu bewerten.
    swatchesEl.addEventListener('click', function () {
      setTimeout(evaluateSchleife, 0);
    });

    function pass() {
      if (!markSwatches()) return false;
      evaluateSchleife();
      return true;
    }
    if (pass()) return;
    // Swatches werden vom Konfigurator-Skript gebaut – ggf. auf sie warten.
    var obs = new MutationObserver(function () {
      if (pass()) obs.disconnect();
    });
    obs.observe(swatchesEl, { childList: true });
    setTimeout(function () { obs.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
